import { render, staticRenderFns } from "./addDishtype.vue?vue&type=template&id=1ad10192&scoped=true"
import script from "./addDishtype.vue?vue&type=script&lang=ts"
export * from "./addDishtype.vue?vue&type=script&lang=ts"
import style0 from "./addDishtype.vue?vue&type=style&index=0&id=1ad10192&prod&lang=scss&scoped=true"
import style1 from "./addDishtype.vue?vue&type=style&index=1&id=1ad10192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad10192",
  null
  
)

export default component.exports